export class UserInfo {
  username: string;
  isDemo: boolean;
  isTry: boolean;
  userId: string;
  teamId?: string;
}

export class UserGroup {
  id: string;
  courseName: string;
  name: string;
  groupId?: string;
  title?: string;
}

interface ModelBase {
  id: string;
  name: string;
}
